export var INITIALS_LENGTH = 2;
export var AVATAR_FALLBACK_CLASSNAME = "vitality-avatar-fallback";